module.exports = __webpack_public_path__ + "img/coupe.455867e2.svg";